import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";

import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import QuestionList from "./QuestionList";
import EditIcon from "@material-ui/icons/Edit";
import AgendaList from "./Agenda/AgendaList";
import { Col } from "reactstrap";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import PresetItems from "./Preset/PresetItems";
import ChatList from "../Chat/ChatList/ChatList";
import ForumTwoToneIcon from "@material-ui/icons/ForumTwoTone";
import { Badge } from "@material-ui/core";
import { MeetingLayouts } from "../ActiveItems/MeetingLayouts/MeetingLayouts";
import NewReleasesIcon from "@material-ui/icons/NewReleases";

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
       <Box p={1}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "#1d1d1d",
  },
}));

export default function ActiveItemsTab(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const unreadMessages = () => {
    const { chats, currentChat } = props;
    let count = 0;
    chats.map((c) => {
      if (c.seen == false) {
        count += c.messages.filter(
          (m) => m.seen == false && m.receiver == "MODERATOR"
        ).length;
      }
    });
    return count;
  };
  let unreadMessageCount = unreadMessages();
  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        color="default"
        style={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <Tabs
          value={value}
          style={{ flexDirection: "column-reverse", display: "inline-flex" }}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          TabScrollButtonProps={{ style: { color: "#ffffff99" } }}
          indicatorColor="primary"
          textColor="primary"
          aria-label="scrollable auto tabs"
        >
      {/*     <Tab
            style={{
              color: value === 0 ? "#ffffffde" : "#ffffff99",
              minWidth: "72px",
            }}
            label={<SystemLabel name="Presets" />}
            {...a11yProps(0)}
          /> */}
          <Tab
            style={{
              color: value === 0 ? "#ffffffde" : "#ffffff99",
              minWidth: "72px",
            }}
            label={
              <span className="flex">
              {/*   <NewReleasesIcon
                  style={{ color: "lightblue", marginRight: 5 }}
                /> */}
                <SystemLabel name="Layouts" />
              </span>
            }
            {...a11yProps(0)}
          />
          <Tab
            style={{
              color: value === 1 ? "#ffffffde" : "#ffffff99",
              minWidth: "72px",
            }}
            label={<SystemLabel name="Questions" />}
            {...a11yProps(1)}
          />
          <Tab
            style={{
              color: value === 2 ? "#ffffffde" : "#ffffff99",
              minWidth: "72px",
            }}
            label={<SystemLabel name="Agenda" />}
            {...a11yProps(2)}
          />
          {props.allowChat ? (
            <Tab
              style={{
                color: value === 3 ? "#ffffffde" : "#ffffff99",
                minWidth: "72px",
              }}
              label={
                <div>
                  <SystemLabel name="Chat" />
                  {"  "}
                  {unreadMessageCount > 0 ? (
                    <Badge
                      color="secondary"
                      badgeContent={unreadMessageCount}
                      max={1000}
                    >
                {/*       <ForumTwoToneIcon /> */}
                    </Badge>
                  ) : null}
                </div>
              }
              {...a11yProps(3)}
            />
          ) : null}
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <MeetingLayouts {...props} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <QuestionList {...props} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <AgendaList {...props} />
      </TabPanel>
      {props.allowChat ? (
        <TabPanel value={value} index={3}>
          <ChatList {...props} />
        </TabPanel>
      ) : null}
    </div>
  );
}
